module.exports = __webpack_public_path__ + "img/piyao-suject-icon-left-wap.d9122fdd.png";